import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import Customer from "@/types/Customer";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CustomerInfo {
  customer: Customer;
}

@Module
export default class CustomerModule extends VuexModule implements CustomerInfo {
  customer = {} as Customer;

  @Mutation
  [Mutations.SET_CUSTOMER](customer) {
    this.customer = customer;
  }

  @Action
  [Actions.CUSTOMER_LIST]() {
    return ApiService.get("Customer")
      .then(({ data }) => {
        this.context.commit(Mutations.SET_CUSTOMER, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  

  @Action
  [Actions.ADD_CUSTOMER](args) {
    return ApiService.post("Customer", args).then(({ data }) => {
      if (!data.success) {
        return data;
      } else {
        //this.context.commit(Mutations.SET_SIZE_SET, data);
        return data;
      }
    });
  }

  @Action
  [Actions.UPDATE_CUSTOMER](args) {
    return ApiService.put("Customer", args).then(({ data }) => {
      if (!data.success) {
        return data;
      } else {
        //this.context.commit(Mutations.SET_SIZE_SET, data);
        return data;
      }
    });
  }

  @Action
  [Actions.REMOVE_CUSTOMER](id) {
    return ApiService.delete("Customer/" + id + "")
      .then(({ data }) => {
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
        return response;
      });
  }
}
